import React from "react";

export default function AivelLogo({
  svgClass = "h-8 w-8",
  rectFillClass = "fill-blue-50",
  strokeThin = "stroke-blue-800 stroke-[24px]",
  strokeThick = "stroke-gray-800 stroke-[48px]",
  circleClass = "fill-blue-500",
}) {
  return (
    <>
      <svg
        className={svgClass}
        viewBox="0 0 300 300"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* 사각형 내부 */}
        <rect x="0" y="0" width="300" height="300" className={rectFillClass} />
        {/* 상단과 좌측 선 (얇게) */}
        <line x1="0" y1="0" x2="300" y2="0" className={strokeThin} />{" "}
        {/* 상단 */}
        <line x1="0" y1="0" x2="0" y2="300" className={strokeThin} />{" "}
        {/* 왼쪽 */}
        {/* 오른쪽과 하단 선 (굵게) */}
        <line x1="300" y1="0" x2="300" y2="300" className={strokeThick} />{" "}
        {/* 오른쪽 */}
        <line x1="0" y1="300" x2="300" y2="300" className={strokeThick} />{" "}
        {/* 하단 */}
        {/* 추가 그래픽 요소 */}
        <line
          x1="0"
          y1="80"
          x2="300"
          y2="80"
          className="stroke-black stroke-[12px] fill-none"
        />
        <line
          x1="0"
          y1="120"
          x2="200"
          y2="120"
          className="stroke-black stroke-[12px] fill-none"
        />
        <circle cx="220" cy="220" r="40" className={circleClass} />
      </svg>
    </>
  );
}
